import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { debounceTime, fromEvent, take } from 'rxjs';

@Directive({
    selector: '[appScrollToInvalidControlOnSubmit]',
    standalone: true,
})
export class ScrollToInvalidControlOnSubmitDirective {
    constructor(
        private el: ElementRef,
        private formGroupDir: FormGroupDirective
    ) {}

    @HostListener('ngSubmit') onSubmit() {
        this.formGroupDir.form.updateValueAndValidity(); // when editing a request again after it's been saved,
        // the formgroup is reinitialized somehow and it's in sync with form state, so updateValueAndValidity() must be called
        if (this.formGroupDir.control.invalid) {
            this.scrollToFirstInvalidControl();
        }
    }

    private scrollToFirstInvalidControl() {
        const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
            'body .ng-invalid:not(form):not(medpace-editable-card):not(medpace-input-card):not(card)'
        );

        const firstDangerMessage: HTMLElement = this.el.nativeElement.querySelector('body .danger-message');

        const element = firstInvalidControl ?? firstDangerMessage ?? this.el.nativeElement;
        window.scroll({
            top: this.getTopOffset(element),
            left: 0,
            behavior: 'smooth',
        });

        fromEvent(window, 'scroll')
            .pipe(debounceTime(100), take(1))
            .subscribe(() => element.focus());
    }

    private getTopOffset(controlEl: HTMLElement): number {
        const labelOffset = 100;
        return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
    }
}
